import {connect} from 'react-redux';
import Page from '../../app/components/Page';
import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import GlobalError from "../../app/components/GlobalError";
import {FormattedMessage} from "react-intl";

export class NoMatch extends Component {



    render() {

        const {showFooter} = this.props;

        return (
            <Page>
                <Page.Header/>
                <GlobalError/>
                <Page.Body>
                    <h1>
                        <FormattedMessage id='frontend.errors.not_found_heading'/>
                    </h1>
                    <h3>
                        <FormattedMessage id='frontend.errors.not_found'/>
                    </h3>
                </Page.Body>
                {showFooter ? <Page.Footer /> : null}
            </Page>
        );
    }
}
export default withRouter(connect(() => ({}))(NoMatch));
